module.exports = __webpack_public_path__ + "img/compact.7e343286.png";